"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustryExpertise = void 0;
var IndustryExpertise;
(function (IndustryExpertise) {
    IndustryExpertise["Aerospace"] = "Aerospace";
    IndustryExpertise["Automotive"] = "Automotive";
    IndustryExpertise["Chemicals"] = "Chemicals";
    IndustryExpertise["Construction"] = "Construction";
    IndustryExpertise["Cosmetics"] = "Cosmetics";
    IndustryExpertise["Ecommerce"] = "Ecommerce";
    IndustryExpertise["FoodAndRestaurants"] = "Food & Restaurants";
    IndustryExpertise["Healthcare"] = "Healthcare";
    IndustryExpertise["Hospitality"] = "Hospitality";
    IndustryExpertise["HomeImprovement"] = "Home Improvement";
    IndustryExpertise["Manufacturing"] = "Manufacturing";
    IndustryExpertise["Medical"] = "Medical";
    IndustryExpertise["Pharmaceuticals"] = "Pharmaceuticals";
    IndustryExpertise["Retail"] = "Retail";
    IndustryExpertise["Technology"] = "Technology";
})(IndustryExpertise = exports.IndustryExpertise || (exports.IndustryExpertise = {}));
